import { Skeleton, Typography, useMediaQuery } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import {
  ButtonAddCart,
  CardRoot,
  classes,
  Code,
  MediaDiv,
  MediaImg,
  Name,
} from "./ItemCard.styles";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { usePartDetails } from "../../../hook/usePartDetails";
import { AppIconsCart, AppIconsCartFilled } from "../../AppIcons";
import AppIconsReplace from "../../AppIcons/AppIconsReplace";
import { PARTS_RESOURCES } from "../../../configuration/Resources";

const ItemCard = (props: any) => {
  const { t } = useTranslation();
  const { openPartDetails } = usePartDetails();

  const handleBasketIconClick = (part: any) => {
    if (part /*&& part.showBasket*/) {
      openPartDetails(part.code, part.replacementCode, part.manufacturerCompanyCode);
    }
  };

  const matches = useMediaQuery("(max-width:359px)");

  return (
    <CardRoot
      onClick={(event: any) => handleBasketIconClick(props.itemObj)}
      style={matches ? { width: "134px" } : {}}
    >
      <MediaDiv>
        {props.itemObj ? (
          <MediaImg
            style={
              props.itemObj.images.length === 0
                ? { width: 180 }
                : matches
                ? { width: "120px", height: "120px" }
                : {}
            }
            src={
              props.itemObj.images.length > 0
                ? PARTS_RESOURCES + "/" +
                  props.itemObj.images[0].fileName.substring(0, 2) +
                  "/" +
                  props.itemObj.images[0].fileName +
                  ".thumb.300.jpg"
                : "/img/imageNotAvailableWhite.svg"
            }
          />
        ) : (
          <div style={{ width: "80%" }}>
            <Skeleton variant="rectangular" width="100%" height="100%" />
          </div>
        )}
      </MediaDiv>

      {props.itemObj && props.itemObj.withReplacement && (
        <AppIconsReplace
          sx={classes.replacements}
          propsIcon={{ fontSize: "small" }}
          title={
            t("common.spareparts.part_detail.replacing") +
            " " +
            props.itemObj.replacementCode
          }
        />
      )}

      {props.itemObj && props.itemObj.showBasket ? (
        <CardContent>
          {" "}
          <Code variant="h6">
            {" "}
            {props.itemObj ? (
              props.itemObj.code
            ) : (
              <div style={{ padding: "0% 28%" }}>
                <Skeleton variant="text"> </Skeleton>
              </div>
            )}
          </Code>
          <Typography variant="body2" color="textSecondary" component="div">
            {props.itemObj ? (
              <>
                <Name>
                  {props.itemObj.description}&nbsp;
                  {props.itemObj.extendedDescription != undefined &&
                  props.itemObj.extendedDescription != null
                    ? props.itemObj.extendedDescription
                    : ""}
                </Name>
              </>
            ) : (
              <div style={{ padding: "0% 18%" }}>
                <Skeleton variant="text"> </Skeleton>
              </div>
            )}
          </Typography>
          {props.itemObj && props.itemObj.showBasket ? (
            <ButtonAddCart>
              <AppIconsCartFilled
                sx={classes.basketCardButton}
                // title={t("common.spareparts.part_detail.show")}
              />
            </ButtonAddCart>
          ) : (
            ""
          )}
        </CardContent>
      ) : (
        <CardContent style={{ paddingRight: 0 }}>
          {" "}
          <Code variant="h6">
            {" "}
            {props.itemObj ? (
              props.itemObj.code
            ) : (
              <div style={{ padding: "0% 28%" }}>
                <Skeleton variant="text"> </Skeleton>
              </div>
            )}
          </Code>
          <Typography variant="body2" color="textSecondary" component="div">
            {props.itemObj ? (
              <>
                <Name>
                  {props.itemObj.description}&nbsp;
                  {props.itemObj.extendedDescription != undefined &&
                  props.itemObj.extendedDescription != null
                    ? props.itemObj.extendedDescription
                    : ""}
                </Name>
              </>
            ) : (
              <div style={{ padding: "0% 18%" }}>
                <Skeleton variant="text"> </Skeleton>
              </div>
            )}
          </Typography>
          {props.itemObj && props.itemObj.showBasket ? (
            <ButtonAddCart>
              <AppIconsCart
                sx={classes.basketCardButton}
                // title={t("common.spareparts.part_detail.show")}
              />
            </ButtonAddCart>
          ) : (
            ""
          )}
        </CardContent>
      )}
    </CardRoot>
  );
};

export default ItemCard;
